
<ng-template #contentmd let-modal>
	<div class="modal-body dashboard_model">
		<div class="col-md-12 d-flex align-items-center justify-content-between">
		  <span class="modal_list_head">ALERT</span>
		  <div class="cancel-del-align">
			<button type="button" class="cstm_btn_css">
			  <img (click)="modal.dismiss(contentmd)" src="./assets/icons/close.svg" alt="Close" class="pointers"/>
			</button>
		  </div>
		</div>
		<div class="col-md-12 mt-3">
		  <table>
			<thead>
			  <tr>
				<th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th>Please select value in all the filters</th>
			  </tr>
			</thead>
		  </table>
		</div>
	  </div>
</ng-template>
<ng-template #content1 let-modal1>
	<div class="modal-body">
		<div class="cancel-del-align">
			<div class="cancel_align">
				<img (click)="modal1.dismiss(content1);filterChangedButNotSavedCheck()"
					src="./assets/icons/material_menu_icons/highlight_off_black_24dp.svg" alt="Close"
					class="pointers">
			</div>
		</div>
		<hr class="custom_hr">
		<div class="row">
			<div class="col-md-6 ">
				<div class="bg-diff diff_cls">
					<div class="geofilter_heading">GEO FILTER</div>
					<hr class="custom_hr1">
					<ng-container *ngFor="let obj1 of modelJsonDropdown|keyvalue:originalOrder;let i=index;">
						<ng-container *ngIf="obj1.key==='geoFilter'">
							<ng-container *ngFor="let obj of modelJsonDropdown['geoFilter'];let i=index;">
								<div class="drop-width dropping_width">
									<ng-select class="filter_select select_cls" #select [items]="obj.value" [closeOnSelect]="false"
										[searchable]="true" [clearable]="false" appendTo="body" [multiple]="true"
										placeholder="All Continent" [(ngModel)]="modelJson[obj1.key][i]['value']"
										(change)="assignLocationData(obj.name,modelJson[obj1.key][i]['value'])">
										<ng-template ng-header-tmp>
											<input type="checkbox" [(ngModel)]="obj['allCheckbox']"
												(change)="onSelectAllGeoFilter($event,obj.name,modelJson[obj1.key][i]['value'],i)">
											<span class="all_heading">&nbsp;All</span>
										</ng-template>
										<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
											<div class="ng-value">{{items.length}} selected</div>
										</ng-template>
									</ng-select>
								</div>
							</ng-container>
						</ng-container>
					</ng-container>
				</div>


			</div>
			<!-- Static Filter -->
			<div class="col-md-6 ">
				<div class="bg-diff static_filter">
					<ng-container *ngFor="let obj1 of modelJsonDropdown|keyvalue:originalOrder;let i=index;">
						<ng-container *ngIf="obj1.value['type'] && obj1.value['type']==='static'">
						<div class="drop-width dropwidth_cls">
								<ng-select placeholder="All Continent" class="filter_select select_cls" #select
									[items]="obj1.value['value']" [closeOnSelect]="false" bindLabel="key"
									bindValue="value" [searchable]="true" [clearable]="false" appendTo="body"
									[multiple]="true" (change)="onChangeStaticFilter(obj1.key,'fromui')"
									[(ngModel)]="modelJson[obj1.key]['value']">
									<ng-template ng-header-tmp>
										<input type="checkbox" [(ngModel)]="modelJsonDropdown[obj1.key]['allCheckbox']"
											(change)="onSelectAllStaticFilter($event,obj1.key,obj1['type'],i)">
										<span class="all_heading">&nbsp;All</span>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
										<div class="ng-value">{{items.length}} selected</div>
									</ng-template>
								</ng-select>
							</div>
						</ng-container>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 ">
				<div class="bg-diff dynamic_filter">
					<!-- Dynamic Filter -->
					<ng-container *ngFor="let obj1 of modelJsonDropdown|keyvalue:originalOrder;let i=index;">
					<ng-container
							*ngIf="(obj1.value['type'] && obj1.value['type']==='dynamic' && obj1.key!='assets')">
                        	<div class="building_name">Building Name</div>
							<div class="drop-width">
								<ng-select class="filter_select select_cls" #select [items]="obj1.value['value']"
									[closeOnSelect]="!buildingMultiSelectFlag" bindLabel="key" bindValue="value"
									[searchable]="true" [clearable]="false" appendTo="body"
									[multiple]="buildingMultiSelectFlag" (change)="getAssetData(i,'fromui',obj1.key)"
									[(ngModel)]="modelJson[obj1.key]['value']">
									<ng-container *ngIf="buildingMultiSelectFlag">
										<ng-template ng-header-tmp>
											<input type="checkbox"
												[(ngModel)]="modelJsonDropdown[obj1.key]['allCheckbox']"
												(change)="onSelectAllStaticFilter($event,obj1.key,obj1['type'],i)">
											<span class="all_heading">&nbsp;All</span>
										</ng-template>
										<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
											<div class="ng-value">{{items.length}} selected</div>
										</ng-template>
									</ng-container>
								</ng-select>
							</div>
						</ng-container>
						<!-- Assets -->
						<ng-container *ngIf="assetShowFlag">
							<ng-container *ngIf="obj1.key==='assets'">
								<ng-container *ngFor="let obj of modelJsonDropdown['assets'];let i=index;">
									<div class="drop-width dropping_width">
										<div class="building_name">{{obj.aliasName}}
										</div>
										<ng-select #select [items]="obj.value" [closeOnSelect]="false" bindLabel="key"
											bindValue="value" [searchable]="true" [clearable]="false" appendTo="body"
											[multiple]="true" [(ngModel)]="modelJson[obj1.key][i]['value']"
											(change)="onChangeAsset(i,'fromui',obj1.key)"
											class="select_cls">
											<ng-template ng-header-tmp>
												<input type="checkbox" [(ngModel)]="obj['allCheckbox']"
													(change)="onSelectAllAssets($event,obj1.key,i)">
												<span class="all_heading">&nbsp;All</span>
											</ng-template>
											<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
												<div class="ng-value">{{items.length}} selected</div>
											</ng-template>
										</ng-select>
									</div>
								</ng-container>
							</ng-container>
						</ng-container>
					</ng-container>
				</div>


			</div>
			<div class="col-md-6"></div>
		</div>




		<div class="row">
			<button type="button" class="newbutton" (click)="onSubmitFinalFilter()">APPLY</button>
		</div>
		<!-- end static -->
	</div>
</ng-template>
<div class="filter_row d-flex align-items-center justify-content-between flex-wrap">

	<div class="MediaQueryFilterHt  filter_lft module_card  d-flex justify-content-between align-items-center cstm_filter">
		<div class="row d-flex">
			<ng-container *ngFor="let obj1 of modelJsonDropdown|keyvalue:originalOrder;let i=index;">
				<ng-container *ngIf="obj1.key==='geoFilter'">
					<ng-container *ngFor="let obj of modelJsonDropdown['geoFilter'];let i=index;">
						<div class="drop-width">
							<ng-select placeholder="{{obj.name}}" class="filter_select geofilter_select" #select [items]="obj.value"
								[closeOnSelect]="false" [searchable]="true" [clearable]="false" appendTo="body"
								[multiple]="true" [(ngModel)]="modelJson[obj1.key][i]['value']"
								(change)="assignLocationData(obj.name,modelJson[obj1.key][i]['value'])" readonly>
								<ng-template ng-header-tmp>
									<input type="checkbox" [(ngModel)]="obj['allCheckbox']"
										(change)="onSelectAllGeoFilter($event,obj.name,modelJson[obj1.key][i]['value'],i)">
									<span  class="dropdown_Text"> All</span>
								</ng-template>
								<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
									<div class="ng-value" >{{obj.name}}   ({{items.length}})</div>
								</ng-template>
							</ng-select>
						</div>
					</ng-container>
				</ng-container>
			</ng-container>
			<!-- Static Filter -->
			<ng-container *ngFor="let obj1 of modelJsonDropdown|keyvalue:originalOrder;let i=index;">
					<ng-container *ngIf="obj1.value['type'] && obj1.value['type']=='static' && obj1.value['name']=='concept'">
						<div class="drop-width">
							<ng-select placeholder="All BG" class="filter_select" #select
								[items]="obj1.value['value']" [closeOnSelect]="false"
								bindLabel="value"
								bindValue="value" 
								[searchable]="true"
								[clearable]="false"
								appendTo="body"
								[multiple]="true" 
								(change)="onChangeStaticFilter(obj1.key,'fromui')"
								[(ngModel)]="modelJson[obj1.key]['value']">
								<ng-template ng-header-tmp>
									<input type="checkbox" [(ngModel)]="modelJsonDropdown[obj1.key]['allCheckbox']"
										(change)="onSelectAllStaticFilter($event,obj1.key,obj1['type'],i)">
									<span class="dropdown_Text"> All</span>
								</ng-template>
								<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
									<div class="ng-value">BG ({{items.length}})</div>
								</ng-template>
							</ng-select>
						</div>
					</ng-container>
				</ng-container>
				<ng-container *ngFor="let obj1 of modelJsonDropdown|keyvalue:originalOrder;let i=index;">
					<ng-container *ngIf="(obj1.value['type'] && obj1.value['type']=='dynamic' && obj1.key!='assets')">
						<div class="drop-width">
							<ng-select placeholder="PLANTS" class="filter_select" #select [items]="obj1.value['value']"
							    [closeOnSelect]="false"
								[searchable]="true" bindLabel="key" bindValue="value" [clearable]="false" appendTo="body"
								[multiple]="buildingMultiSelectFlag" (change)="getAssetData(i,'fromui',obj1.key)"
								[(ngModel)]="modelJson[obj1.key]['value']">
								<ng-container *ngIf="buildingMultiSelectFlag">
									<ng-template ng-header-tmp>
										<input type="checkbox" [(ngModel)]="modelJsonDropdown[obj1.key]['allCheckbox']"
											(change)="onSelectAllStaticFilter($event,obj1.key,obj1['type'],i)">
										<span class="dropdown_Text"> All</span>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items" let-clear="clear" >
										<div class="ng-value">Plants ({{items.length}})</div>
									</ng-template>
								</ng-container>
							</ng-select>
						</div>
					</ng-container>
				<!--Assets -->
			</ng-container>
		</div>
		<div class="row">
			<button type="button" class="cstm_btn_css filter_btn m-0" (click)="onSubmitFinalFilter(contentmd)">APPLY</button>
		</div>
	</div>

	<div class="filter_rgt module_card d-flex align-items-center justify-content-between" [ngClass]="disableFilter ? 'disableFilter':''">
		<app-quickrange [resetAll]="resetDate" (onFilterChange)="onIntervalChange($event)"
		[disableFilter]="disableFilter" [disableArr]="disableArr" [selectedFilterValue]="selectedFilterValue"  [msgFromFilter]="filterMsg" class="qiuck_range"></app-quickrange>
		<div class="custom_date_range" >
			<mat-form-field appearance="none" >
				<mat-label>Custom Date Range</mat-label>
				<mat-date-range-input [rangePicker]="dateRangePicker" disabled={{customDateDisableFlag}} [max]="maxDate" [min]="minDate" >
					<input matStartDate placeholder="Start date" [(ngModel)]="startdateRange" readonly>
					<input matEndDate placeholder="End date" [(ngModel)]="enddateRange" 
						(dateChange)="dateRangeChange()" readonly>
				</mat-date-range-input>
				<mat-datepicker-toggle matSuffix [for]="dateRangePicker" (click)=" togglecard($event)">
				</mat-datepicker-toggle>
				<mat-date-range-picker #dateRangePicker (opened)="onDatepickerOpen()"
				(closed)="onDatepickerClose()"></mat-date-range-picker>
				<!-- <div *ngIf="showCard" class="card card_style" (click)="onCardClick($event)">
					<select name="shifts" class="select_cls form-control" [(ngModel)]="selectedShift"  (change)="shiftWiseChange()">
						<option value="null" [disabled]="true">Select Shift</option>
						<option value="shift1">Shift 1</option>
						<option value="shift2">Shift 2</option>
						<option value="shift3">Shift 3</option>
					</select>
				  </div>  -->
				  <!--this is required for next deployment-->
			</mat-form-field>
			<div>
		</div>
	</div>
</div>
</div>